import type { Component } from 'vue'

import type { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './Gallery.translations'

export type ReassuranceImagesType = Array<{
  src: string
  alt: string
  description?: { text: string; icon: Component }
}>

// This list is on the front side for the experiment, but if it wins this needs to go on the backend side.
const CATEGORY_WITH_BATTERY = [
  '2',
  '110',
  '528',
  '5',
  '170',
  '9',
  '12',
  '11',
  '117',
  '216',
  '109',
  '559',
  '217',
  '115',
  '158',
  '18',
]

export const getJPReassuranceImages = (
  category: string,
  type: string,
  i18n: ReturnType<typeof useI18n>,
) => {
  const images = []

  if (type !== 'Refurbished') {
    return []
  }

  const warranty = {
    src: '/img/product/jp/gallery/warranty.png',
    alt: i18n(translations.warrantyJPDescription),
  }

  const battery = {
    src: '/img/product/jp/gallery/battery.png',
    alt: i18n(translations.batteryJPDescription),
  }

  const insurance = {
    src: '/img/product/jp/gallery/insurance.png',
    alt: i18n(translations.insuranceJPDescription),
  }

  images.push(warranty)
  images.push(insurance)
  if (CATEGORY_WITH_BATTERY.includes(category)) {
    images.push(battery)
  }

  return images
}
